import { createSlice } from '@reduxjs/toolkit';
import { Activity, QueryManagerSummary, QueueActivity } from '@/types/activity';
import {
  clearBadge,
  closeActivity,
  fetchActivitiesSummary,
  fetchCaseActivities,
  fetchQueueActivities,
  raiseQuery,
} from './activityThunks';

interface ActivityState {
  queue: QueueActivity[];
  caseActivities: Activity[];
  summary: QueryManagerSummary | null;
  loading: boolean;
  error: string | null;
}

const initialState: ActivityState = {
  queue: [],
  caseActivities: [],
  summary: null,
  loading: false,
  error: null,
};

const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQueueActivities.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(fetchQueueActivities.fulfilled, (s, a) => {
        s.loading = false;
        s.queue = a.payload;
      })
      .addCase(fetchQueueActivities.rejected, (s, a) => {
        s.loading = false;
        s.error = a.error.message ?? 'Error';
      })
      .addCase(fetchActivitiesSummary.fulfilled, (s, a) => {
        s.summary = a.payload;
      })
      .addCase(fetchCaseActivities.pending, (s) => {
        s.loading = true;
      })
      .addCase(fetchCaseActivities.fulfilled, (s, a) => {
        s.loading = false;
        s.caseActivities = a.payload;
      })
      .addCase(fetchCaseActivities.rejected, (s, a) => {
        s.loading = false;
        s.error = a.error.message ?? 'Error';
      })
      .addCase(raiseQuery.fulfilled, (s, a) => {
        s.caseActivities.unshift(a.payload.activity);
      })
      .addCase(closeActivity.fulfilled, (s, a) => {
        const idx = s.queue.findIndex((q) => q.id === a.payload.id);
        if (idx !== -1) s.queue.splice(idx, 1);
        const cIdx = s.caseActivities.findIndex((c) => c.id === a.payload.id);
        if (cIdx !== -1) s.caseActivities[cIdx] = a.payload;
      })
      .addCase(clearBadge.fulfilled, (state, action) => {
        const item = state.caseActivities.find((a) => a.id === action.payload);
        if (item) item.notification_badge = false;
      });
  },
});

export default activitySlice.reducer;
